import { render, staticRenderFns } from "./CustomerHeader.vue?vue&type=template&id=4d2f86da&scoped=true"
import script from "./CustomerHeader.vue?vue&type=script&lang=ts"
export * from "./CustomerHeader.vue?vue&type=script&lang=ts"
import style0 from "./CustomerHeader.vue?vue&type=style&index=0&id=4d2f86da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2f86da",
  null
  
)

export default component.exports